/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {NotificationType} from "../../util/enums";
import Notification from "../../models/notificationModel";
import {AppContext} from "../misc/appContext";
import {ResponseData, showDialog} from "@dvrd/dvr-controls";
import {createErrorMessage} from "../../util/utils";

type RetType = [Array<Notification>, Dispatch<SetStateAction<Array<Notification>>>, boolean, Dispatch<SetStateAction<boolean>>, VoidFunction];

export default function useNotifications(notificationType: NotificationType): RetType {
    const {account} = useContext(AppContext).accountContext;
    const [notifications, setNotifications] = useState<Array<Notification>>([]);
    const [loading, setLoading] = useState(true);

    function loadNotifications() {
        setLoading(true);
        if (!account) return setLoading(false);
        Notification.getByType(account.id, notificationType,
            (notifications: Array<Notification>, success: boolean, data: ResponseData) => {
                setLoading(false);
                if (success) setNotifications(notifications);
                else showDialog(createErrorMessage(data.message ?? 'Er zijn geen notificaties gevonden.'),
                    'Notificaties niet gevonden');
            });
    }

    useEffect(() => {
        loadNotifications();
    }, [notificationType, account?.id]);

    return [notifications, setNotifications, loading, setLoading, loadNotifications];
}